export default {
    // 商户列表
    list: {
        method: 'get',
        url: '/tenants'
    },
    // 商户列表（快速搜索）
    quickSearchList: {
        method: 'get',
        url: '/tenants/quick_search'
    },
    // 新增商户
    add: {
        method: 'post',
        url: '/tenants'
    },
    // 商户详情
    detail: {
        method: 'get',
        url: '/tenants/:id'
    },
    // 商户详情
    edit: {
        method: 'patch',
        url: '/tenants/:id'
    },
    // 商户小程序列表
    antList: {
        method: 'get',
        url: '/ant_mini_programs'
    },
    // 商户小程序编辑
    antEdit: {
        method: 'patch',
        url: '/ant_mini_programs/:id'
    },
    // 商户小程序列表（指定商户）
    antTenantList: {
        method: 'get',
        url: '/tenants/:id/ant_mini_programs'
    },
    // 商户小程序.直付通进件查询
    zftProgressSearch: {
        method: 'get',
        url: '/ant_mini_programs/:id/zft_progress'
    },
    // 商户小程序.直付通进件
    zftProgress: {
        method: 'post',
        url: '/ant_mini_programs/:id/zft_progress'
    },
    // 商户小程序.建立分账关系
    addTradeSplit: {
        method: 'post',
        url: '/ant_mini_programs/:id/trade_split'
    },
    // 商户产品分类列表
    productCategoriesList: {
        method: 'get',
        url: '/tenants/:id/tenant_product_categories'
    },
    // 商户上架产品列表
    productCategories: {
        method: 'get',
        url: '/tenants/:id/tenant_products'
    },
    // 商户上架产品批处理
    batchProductCategories: {
        method: 'post',
        url: '/tenants/:id/tenant_products/batch_process'
    },
    // 商户分账配置信息
    tradeSplitList: {
        method: 'get',
        url: '/tenants/:id/trade_split_settings'
    },
    // 商户分账配置设置
    editTradeSplit: {
        method: 'post',
        url: '/tenants/:id/trade_split_settings'
    },
}


// WEBPACK FOOTER //
// ./src/api/tenants.js